import { Link } from "react-router-dom";
import PageTitle from "../../../../components/partials/PageTitle";
import { MdRemoveRedEye } from "react-icons/md";
import { LoaderTwo } from "../../../../components/loader/LoaderTwo";
import { useEffect, useRef, useState } from "react";
import AddCoinsuranceCompany from "../../../../components/modals/co-insurance/AddCoinsuranceCompany";
import ModalContainer from "../../../../components/modals/ModalContainer";
import { useDispatch } from "react-redux";
import { getAllCoinsurace } from "../../../../redux/slice/coinsurance/coinsuraceSlice";
import { useSelector } from "react-redux";
import PaginationLinks from "../../../../components/pagination/PaginationLinks";
import { useReactToPrint } from "react-to-print";
import excel from "../../../../assets/images/img-icons/excel.png";
import { CSVLink } from "react-csv";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import EditCoinsuranceCompany from "../../../../components/modals/co-insurance/EditCoinsuranceCompany";

const CoinsuranceCompanies = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [id, setId] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCoinsurace({ pageNumber: pageNumber }));
  }, []);

  const fetchCoinsuranceHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(
      getAllCoinsurace({
        pageNumber: pageNum,
      })
    );
  };

  const { coinsuranceData, isLoading } = useSelector(
    (state) => state.coinsurance
  );

  const breadcrumb = {
    from: {
      title: "Co-insurance",
      link: "/admin/settings/co-insurance",
    },
    current: {
      title: "Coinsurance Companies Table",
      link: null,
    },
  };

  const CCPdfRef = useRef();
  const [filterBy, setFilterBy] = useState("");

  //co-insurance companies
  const coinsuranceCompanies = coinsuranceData?.data || [];

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "co-insurance companies",
  });

  // export data to excel file
  const exportXlsxData = () => {
    const itemsWithValues = {};
    return coinsuranceCompanies?.map((item) => {
      for (const key in item) {
        if (item[key]) {
          let keyChange = key?.split("_")?.join(" ");
          itemsWithValues[keyChange] = item[key];
        }
      }
      return itemsWithValues;
    });
  };

  // const dispatch = useDispatch()/

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterBy?.length) {
      const payload = {
        search: filterBy,
        pageNum: 1,
      };
      // dispatch(getAllLifeCover(payload));
    }
  };

  // useEffect(() => {
  //   if (!filterBy) {
  //     dispatch(getAllLifeCover({pageNum:1, search: ''}));
  //   }
  //   }, [dispatch, filterBy]);

  //   useEffect(() => {
  //     if (isSuccess) {
  //       dispatch(resetLifeCoverStatus());
  //     }
  //   }, [dispatch, isSuccess]);

  if (coinsuranceCompanies?.length === 0 && isLoading) {
    return (
      <div className="mt-2">
        <LoaderTwo />
      </div>
    );
  }
  return (
    <>
      {/* page title */}
      <PageTitle title="Co-insurance" breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className="row card p-1" style={{ margin: "auto 1px" }}>
        <div className="mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0">
          <div className={`d-flex justify-content-between align-items-center`}>
            <div>
              <button
                className="d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3 py-1"
                style={{ height: "30px", padding: "10px 10px" }}
                data-bs-toggle="modal"
                data-bs-target="#addCoinsuranceCompany"
              >
                <span>
                  <i className="mdi mdi-plus fs-4"></i>
                </span>
                <span className="text-dark pe-2 text-white">Add Company</span>
              </button>
            </div>
            <div className="d-flex justify-content-between align-items-center gap-3">
              <form
                onSubmit={handleSearch}
                className="d-flex bg-primary-1 align-items-center "
                style={{ height: "30px", width: "217px" }}
              >
                <input
                  type="search"
                  value={filterBy}
                  className="border-0"
                  placeholder="Search..."
                  onChange={(e) => setFilterBy(e.target.value)}
                  style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button
                  type="submit"
                  className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                  style={{ height: "28px" }}
                >
                  <i className="uil uil-search text-white fs-4"></i>
                </button>
              </form>
              <div className=" d-flex align-items-center border ">
                <span
                  className="bg-info me-2 text-white"
                  style={{ padding: "3px" }}
                >
                  Export to
                </span>
                <span
                  href="#"
                  id="btnExport"
                  className="me-1"
                  title="Export to Pdf"
                  onClick={generatePDF}
                >
                  <img src={pdf} alt="export-pdf" style={{ height: "20px" }} />
                </span>
                <CSVLink
                  data={exportXlsxData()}
                  style={{ fontWeight: "bolder" }}
                  filename="Available Users"
                >
                  <span
                    href="#"
                    id="btnExport"
                    className="mr-1"
                    title="Export to Excel"
                  >
                    <img
                      src={excel}
                      alt="export-excel"
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="position-relative">
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive">
                  <table
                    className="table table-centered table-striped nowrap w-100 no-footer"
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className="sorting"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "225.8px" }}
                          aria-label="Customer: activate to sort column ascending"
                        >
                          Company Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "167.8px" }}
                          aria-label="Email: activate to sort column ascending"
                        >
                          Description
                        </th>
                        <th
                          className="sorting"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "167.8px" }}
                        >
                          Date Created
                        </th>
                        <th
                          className="sorting text-center"
                          tabIndex="0"
                          rowSpan="1"
                          colSpan="1"
                          style={{ width: "95.8px" }}
                          aria-label="Status: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {coinsuranceCompanies?.length ? (
                      <tbody>
                        {coinsuranceCompanies?.map((item) => {
                          return (
                            <tr key={item?.id}>
                              <td>
                                <span>
                                  {item.company_name.charAt(0).toUpperCase() +
                                    item.company_name.slice(1)}
                                </span>
                              </td>

                              <td className="">{item?.description}</td>
                              <td className="">
                                {new Date(item?.created_at).toLocaleString(
                                  "en-US",
                                  {
                                    dateStyle: "medium",
                                  }
                                )}
                              </td>
                              <td className="text-center">
                                <button
                                  onClick={() => {
                                    setId(item?.id);
                                  }}
                                  className="  cursor-p "
                                  style={{
                                    height: "fit-content",
                                    width: "fit-content",
                                    border: "none",
                                    background: "none",
                                  }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#editCoinsuranceCompany"
                                >
                                  <MdRemoveRedEye
                                    className="text-primary"
                                    style={{
                                      fontSize: "20px",
                                      textAlign: "start",
                                    }}
                                  />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {coinsuranceCompanies?.length < 1 ? (
                  <h5 className="alert alert-info">No result found!</h5>
                ) : null}
                <div className="row mt-2">
                  <div className="col-sm-12 col-md-6">
                    <div
                      className="dataTables_info table-pages"
                      id="products-datatable_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing all company {coinsuranceData?.from} to{" "}
                      {coinsuranceData?.to} of {coinsuranceData?.total}
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <PaginationLinks
                      paginationData={coinsuranceCompanies}
                      getNextPage={() => fetchCoinsuranceHandler(pageNumber)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalContainer
        modal_id="addCoinsuranceCompany"
        modal_width="modal-md"
        bradius="rounded-2"
      >
        <AddCoinsuranceCompany />
      </ModalContainer>

      <ModalContainer
        modal_id="editCoinsuranceCompany"
        modal_width="modal-md"
        bradius="rounded-2"
      >
        <EditCoinsuranceCompany id={id} />
      </ModalContainer>
    </>
  );
};

export default CoinsuranceCompanies;
